export default "__VITE_PUBLIC_ASSET__55ffb1eb__"